import { createAction } from '@reduxjs/toolkit';

export const footerUpdateId = createAction('footer/updateId');
export const footerUpdateIsAdded = createAction('footer/updateIsAdded');
export const footerUpdateIsActive = createAction('footer/updateIsActive');

export const footerStore = createAction('footer/store');
export const footerClear = createAction('footer/clear');

export const footerUpdateRequest = createAction('footer/updateRequest');
export const footerUpdateError = createAction('footer/updateError');
export const footerUpdateStore = createAction('footer/updateStore');

export const footerUpdateItems = createAction('footer/updateItems');

export const footerUpdateHeadingTitle = createAction('footer/updateHeadingTitle');
export const footerUpdateHeadingDescription = createAction('footer/updateHeadingDescription');
export const footerUpdateHeadingTextAlign = createAction('footer/updateHeadingTextAlign');
export const footerUpdateHeadingImage = createAction('footer/updateHeadingImage');
export const footerUpdateHeadingDivider = createAction('footer/updateHeadingDivider');

export const footerUpdateSectionIsBackground = createAction('footer/updateSectionIsBackground');
export const footerUpdateSectionTextColor = createAction('footer/updateSectionTextColor');
export const footerUpdateSectionBackgroundColor = createAction('footer/updateSectionBackgroundColor');
export const footerUpdateSectionOpacity = createAction('footer/updateSectionOpacity');
export const footerUpdateSectionIsFullWidth = createAction('footer/updateSectionIsFullWidth');
export const footerUpdateSectionShadow = createAction('footer/updateSectionShadow');
export const footerUpdateSectionShadowColor = createAction('footer/updateSectionShadowColor');
export const footerUpdateSectionPadding = createAction('footer/updateSectionPadding');
export const footerUpdateSectionMargin = createAction('footer/updateSectionMargin');
export const footerUpdateSectionBackgroundType = createAction('footer/updateSectionBackgroundType');
export const footerUpdateSectionBackgroundImage = createAction('footer/updateSectionBackgroundImage');
export const footerUpdateSectionGradientColor1 = createAction('footer/updateSectionGradientColor1');
export const footerUpdateSectionGradientColor2 = createAction('footer/updateSectionGradientColor2');
export const footerUpdateSectionGradientDirection = createAction('footer/updateSectionGradientDirection');
export const footerUpdateSectionGradientOffset = createAction('footer/updateSectionGradientOffset');
export const footerUpdateSectionBorder = createAction('footer/updateSectionBorder');
export const footerUpdateSectionBorderColor = createAction('footer/updateSectionBorderColor');
export const footerUpdateSectionShadowBorderColor = createAction('footer/updateSectionShadowBorderColor');
export const footerUpdateSectionShape = createAction('footer/updateSectionShape');

export const updateIsDisplayOnEveryPage = createAction('footer/updateIsDisplayOnEveryPage');
export const footerUpdateBackgroundImage = createAction('footer/updateBackgroundImage');
